import { render } from "./TemplateMfittBookingMailSentError.vue?vue&type=template&id=efaedda0&scoped=true"
import script from "./TemplateMfittBookingMailSentError.vue?vue&type=script&lang=js"
export * from "./TemplateMfittBookingMailSentError.vue?vue&type=script&lang=js"

import "./TemplateMfittBookingMailSentError.vue?vue&type=style&index=0&id=efaedda0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-efaedda0"

export default script